import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./report-mng-criteria-frm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./report-mng-criteria-frm.component.scss?ngResource";
import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { UcFirstPipe } from "ngx-pipes";
import { ReportCriteriaConst } from "../../report-form/report-criteria-form/report-criteria-constants";
import { ReportCriteriaFormComponent } from "../../report-form/report-criteria-form/report-criteria-form.component";
import { ReportService } from "../../report-form/report.service";
import { ReportMngCriteriaInit } from "./report-mng-param-builder";
import { SelectedApplicationService } from "../../../services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { CRUDOperation } from "../../../models/crud-operation-enum.model";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
let ReportMngCriteriaFrmComponent = class ReportMngCriteriaFrmComponent extends ReportCriteriaFormComponent {
    sevice;
    formBuilder;
    changeDetectorRefs;
    datePipe;
    ucFirst;
    selectedApplicationService;
    appController;
    inReportName;
    inReportGoup;
    uploadReport = ReportCriteriaConst.UPLOAD_REPORT;
    uploadReportCtrl = ReportCriteriaConst.UPLOAD_REPORT_CONTOL;
    componentTypeCtrl = ReportCriteriaConst.COMPONENT_TYPE_CONTOL;
    jobIdCtrl = ReportCriteriaConst.JOB_ID_CONTOL;
    application;
    jobID;
    componentType;
    referenceNumber;
    selectedApplicationSubscription;
    constructor(sevice, formBuilder, changeDetectorRefs, datePipe, ucFirst, selectedApplicationService, appController) {
        super(formBuilder, appController, changeDetectorRefs, datePipe, ucFirst, sevice);
        this.sevice = sevice;
        this.formBuilder = formBuilder;
        this.changeDetectorRefs = changeDetectorRefs;
        this.datePipe = datePipe;
        this.ucFirst = ucFirst;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
    }
    initReportBuilder() {
        const builder = new ReportMngCriteriaInit(this.ucFirst, this.datePipe, this.reportMetadata, this.reportParametersForm, this.application, this.jobID);
        // set after form is fully initialized
        setTimeout(() => this.populateReferenceNumber(), 0);
        return builder;
    }
    listenToReportChange() {
        this.subscribeToSelectedApplication();
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription =
            this.selectedApplicationService.$selectedApplication
                .subscribe({
                next: (app) => {
                    this.application = app;
                    super.listenToReportChange();
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(ReportCriteriaConst.CRITERIA_TITLE, error, CRUDOperation.Get);
                }
            });
    }
    populateReferenceNumber() {
        if (!this.referenceNumber || !this.reportMetadata?.reportCriteria || !this.reportParametersForm) {
            return;
        }
        const referenceNumberCriteria = this.reportMetadata.reportCriteria.find(criteria => criteria.CriteriaName?.toLowerCase() === 'referencenumber');
        const criteriaFormArray = this.reportParametersForm.get(this.reportCriteriaControl);
        if (!referenceNumberCriteria || !criteriaFormArray) {
            return;
        }
        const referenceNumberIndex = this.reportMetadata.reportCriteria.indexOf(referenceNumberCriteria);
        if (referenceNumberIndex !== -1 && referenceNumberIndex < criteriaFormArray.length) {
            const referenceNumberFormGroup = criteriaFormArray.at(referenceNumberIndex);
            const valueControl = referenceNumberFormGroup?.get('CriteriaFieldValue');
            if (valueControl) {
                valueControl.setValue(this.referenceNumber);
                valueControl.disable();
                this.changeDetectorRefs.detectChanges();
            }
        }
    }
    static ctorParameters = () => [
        { type: ReportService },
        { type: FormBuilder },
        { type: ChangeDetectorRef },
        { type: DatePipe },
        { type: UcFirstPipe },
        { type: SelectedApplicationService },
        { type: AppControllerService }
    ];
    static propDecorators = {
        inReportName: [{ type: Input }],
        inReportGoup: [{ type: Input }],
        jobID: [{ type: Input }],
        componentType: [{ type: Input }],
        referenceNumber: [{ type: Input }]
    };
};
ReportMngCriteriaFrmComponent = __decorate([
    Component({
        selector: "app-report-mng-criteria-frm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ReportMngCriteriaFrmComponent);
export { ReportMngCriteriaFrmComponent };
